<template>
  <NavBar />
  <MastheadSection />
  <ServiceSection />
  <ProjectsSection />
  <PricingSection />
  <AboutSection />
  <ContactSection />
  <AppFooter />
</template>

<script setup>
  import { watch, onMounted, nextTick } from 'vue'
  import { useI18n } from 'vue-i18n'
  import NavBar from './components/NavBar.vue'
  import MastheadSection from './components/MastheadSection.vue'
  import ServiceSection from './components/ServiceSection.vue'
  import ProjectsSection from './components/ProjectsSection.vue'
  import PricingSection from './components/PricingSection.vue'
  import AboutSection from './components/AboutSection.vue'
  import ContactSection from './components/ContactSection.vue'
  import AppFooter from './components/AppFooter.vue'

  const { locale } = useI18n()

  watch(locale, (newLocale) => {
    document.documentElement.lang = newLocale
  })

  onMounted(() => {
    nextTick(() => {
      const $ = window.$

      // Smooth scrolling + close mobile nav
      $('a.js-scroll-trigger[href*="#"]:not([href="#"])').on('click', function (event) {
        $('.navbar-collapse').collapse('hide')
        if (
          location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
          location.hostname === this.hostname
        ) {
          const target = $(this.hash).length ? $(this.hash) : $('[name=' + this.hash.slice(1) + ']')
          if (target.length) {
            event.preventDefault()
            $('html, body').animate({ scrollTop: target.offset().top - 70 }, 1000, 'easeInOutExpo')
          }
        }
      })

      // Scrollspy
      $('body').scrollspy({ target: '#mainNav', offset: 100 })

      // Navbar shrink on scroll
      const navbarShrink = () => {
        if ($('#mainNav').offset().top > 100) {
          $('#mainNav').addClass('navbar-shrink')
        } else {
          $('#mainNav').removeClass('navbar-shrink')
        }
      }
      navbarShrink()
      $(window).on('scroll', navbarShrink)

      // ekko-lightbox
      $(document).on('click', '[data-toggle="lightbox"]', function (event) {
        event.preventDefault()
        $(this).ekkoLightbox()
      })
    })
  })
</script>